export enum InspectionStatus {
  UNINSPECTION = 'UNINSPECTION',
  NOTINSEPCTION = 'NOTINSEPCTION',
  COMPLETE = 'COMPLETE',
}
